import { ApplicationState } from "../index";

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.merchant.data?.data?.find((x) => x.id === id);
}
